<template>
  <div class="redirect-to-discount-popup" :class="{ loading }">
    <popup :buttons="buttons" :close-action="closeModal">
      <template v-slot:title>
        <img class="logo-image" :src="require('@/assets/bank-logos-30/discount.svg')">
        <div class="popup-title">רגע לפני שנעבור לאתר דיסקונט...</div>
      </template>
      <template v-slot:content>
        <div class="description">
          <span>מיד נעביר אותך מאתר riseup לאתר בנק דיסקונט. תמיד אפשר לחזור לתהליך ההרשמה </span>
            <span class="bold"> דרך הלינק שנשלח אליך ב- WhatApp.</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import DiscountApi from '../../../api/DiscountApi';
import Segment from '../../../Segment';

export default {
  name: 'RedirectToDiscountPopup',
  props: {
    saveDiscountCredentials: {
      type: Function,
      required: true,
    },
    idNumber: {
      type: String,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('RedirectToDiscountPopupShown');
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Popup: BaseUI.Popup,
  },
  computed: {
    buttons() {
      return [
        {
          title: 'המשך לאתר דיסקונט',
          variant: 'discount',
          action: this.redirectToGetAccessCode,
          loading: this.loading,
          size: 'slim',
        },
        {
          title: 'אמשיך בפעם אחרת',
          variant: 'secondary',
          action: this.closeModal,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    ...mapActions('credentials', ['updatePendingCredentials']),
    closeModal() {
      Segment.trackUserInteraction('RedirectToDiscountPopup_CloseClicked', { idNumber: this.idNumber });
      this.$emit('close');
    },
    async redirectToGetAccessCode() {
      this.loading = true;
      Segment.trackUserInteraction('RedirectToDiscountPopup_ContinueInDiscountClicked', { idNumber: this.idNumber });
      const { credentialsId } = await this.saveDiscountCredentials();
      const redirectUrl = await DiscountApi.getAccessCodeUrl(this.idNumber, credentialsId);
      window.location.href = redirectUrl;
    },
  },
};
</script>

<style lang="scss" scoped>

  .redirect-to-discount-popup {

    &.loading{
      opacity: 0.5;
      pointer-events: none;
    }

    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 18px;
    }

    .logo-image {
      height: 40px;
      margin-bottom: 20px;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 60px;
      line-height: 20px;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/discount/RedirectToDiscountPopup.vue